import { getVersion } from 'prosemirror-collab';
import { EditorState } from 'prosemirror-state';
import { SendCurrentCursorPosition } from './types';
import { getSendableSelection } from './getSendableSelection';
import { Selection } from 'prosemirror-state';

let ownSelection: Selection | null = null;

/**
 * Updates the state of the editor's own cursor changes and sends the current cursor position to other clients.
 * @param newState - The new editor state.
 * @param clientID - The ID of the client.
 * @param sendCurrentCursorPosition - A function that sends the current cursor position to other clients.
 */
export function updateOwnCursorChanges(
  newState: EditorState,
  clientID: string,
  sendCurrentCursorPosition: SendCurrentCursorPosition,
) {
  const selectionChanged =
    (!ownSelection && newState.selection) ||
    (ownSelection && !newState.selection.eq(ownSelection));

  if (selectionChanged) {
    let version: number;
    try {
      version = getVersion(newState);
    } catch (err) {
      // Collab plugin not configured yet, ignore
      return;
    }
    ownSelection = newState.selection;
    const sendableSelection = getSendableSelection(ownSelection);
    sendCurrentCursorPosition(sendableSelection, clientID, version);
  }
}
